import * as stylex from "@stylexjs/stylex";
import Tippy from "@tippy.js/react";
import { useRTL } from "hooks";
import "tippy.js/dist/tippy.css";
import * as M from "../materials";
import { colors } from "../materials/consts.stylex";
import { typography } from "../materials/typography.stylex";
// It should be safe to cast this to "any" because we wrap it. We need to do
// this because "styled" omits some props it can't deal with, it seems …
const SHARED_PROPS = {
    maxWidth: "304px",
    zIndex: M.zIndex.tooltip,
    placement: "bottom"
};
// `.tippy-arrow` is internal to tippy.js's own DOM structure — not an element we render —
// so StyleX can't reach it. Its rules stay in style.global.css, scoped by the
// "gem-chart-tippy" marker class applied below.
function mergeClassName(stylexClassName, marker, className) {
    return [
        marker,
        stylexClassName,
        className
    ].filter(Boolean).join(" ");
}
function ChartTooltipContainer({ children, className, ...overrides }) {
    return <Tippy {...SHARED_PROPS} className={mergeClassName({
        className: "x12peec7 x1cum3z5 xtxiqt8 xtrmz3t"
    }.className, "gem-chart-tippy", className)} {...overrides}>
      {children}
    </Tippy>;
}
const stylexStyles = {
    chartTitle: {
        k63SB2: "x117nqv4",
        kMwMTN: "xjvpvmj",
        k1K539: "x12nagc",
        $$css: true
    },
    chartBody: {
        kMwMTN: "xjvpvmj",
        k1K539: "x1wsgfga",
        $$css: true
    },
    rowItemLtr: {
        kE3dHu: "x163pfp",
        $$css: true
    },
    rowItemRtl: {
        kpe85a: "xy13l1i",
        $$css: true
    },
    rowItemFirstLtr: {
        kE3dHu: "x1uhho1l",
        $$css: true
    },
    rowItemFirstRtl: {
        kpe85a: "x1xpa7k",
        $$css: true
    },
    rowItemLastLtr: {
        koQZXg: "x8x9d4c",
        $$css: true
    },
    rowItemLastRtl: {
        km5ZXQ: "xack27t",
        $$css: true
    }
};
export function ChartTooltip({ children, content, title, ...props }) {
    return <ChartTooltipContainer content={<>
          <h2 {...stylex.props(typography.meta, stylexStyles.chartTitle)}>{title}</h2>
          <div {...stylex.props(typography.meta, stylexStyles.chartBody)}>{content}</div>
        </>} {...props}>
      {children}
    </ChartTooltipContainer>;
}
// -----------------------------------------------------------------------------
// GridBody
export function TooltipGridBody({ rows }) {
    const isRTL = useRTL();
    return <div>
      {rows.map((row, i)=><div key={i} className="x78zum5 x1nhvcw1">
          {row.map((item, j)=><div key={j} {...stylex.props(isRTL ? stylexStyles.rowItemRtl : stylexStyles.rowItemLtr, j === 0 && (isRTL ? stylexStyles.rowItemFirstRtl : stylexStyles.rowItemFirstLtr), j === row.length - 1 && (isRTL ? stylexStyles.rowItemLastRtl : stylexStyles.rowItemLastLtr))}>
              {item}
            </div>)}
        </div>)}
    </div>;
}
/**
 * Simplified version of TooltipGridBody
 *
 * - Expects the first element to be a color string.
 * - Only accepts strings, not ReactNodes
 */ export function TooltipGridBodyWithLegend({ rows }) {
    return <TooltipGridBody rows={rows.map(([color, ...rest])=>[
            <div key={""} className="x1c4vz4f x1n2onr6 xndqk7f x1xc55vz xdk7pt x16rqkct" style={{
                backgroundColor: color
            }}></div>,
            ...rest
        ])}/>;
}
